import { IFilterHipoModel } from "../interfaces/hipo/IFilterHipoModel";

export class FilterHipoModel implements IFilterHipoModel{
    sedes: number[];
    contratista: string;
    anios: number[];
    fechaInicioEvento?: Date;
    fechaFinEvento?: Date;
    page: number;
    pageSize: number;
    categorias: number[];
    tiposregla: number[];
    tipoaccidente: number[];
    proyecto: string
    idCompania: number;

    constructor(){
        this.sedes = [];
        this.tipoaccidente = [];
        this.contratista = '';
        this.anios=[];
        this.page = 1;
        this.pageSize = 30;
        this.categorias = [];
        this.tiposregla = [];
        this.proyecto = '';
        this.idCompania = 0;
    }
}